export default __webpack_public_path__ + "static/media/rabbit_type_6_1.f0fe3051.svg";